import { render, staticRenderFns } from "./FlagshipIndex.vue?vue&type=template&id=fa9331c4&scoped=true"
import script from "./FlagshipIndex.vue?vue&type=script&lang=js"
export * from "./FlagshipIndex.vue?vue&type=script&lang=js"
import style0 from "./FlagshipIndex.vue?vue&type=style&index=0&id=fa9331c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9331c4",
  null
  
)

export default component.exports